import React from 'react'
import ProfileAttributeTableFragmentGenerator from '../../../utils/TableGenerator/ProfileAttributeTableFragmentGenerator'

interface NumberOfSitesTabProps {
    valueChangeHandler: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
    data: Record<string, number | null>,
    keys: string[]
}

function NumberOfSitesTab(props: NumberOfSitesTabProps) {
    const { valueChangeHandler, data, keys } = props

    return (
        <table className="table-with-border pie-table accordion-content">
            <thead>
                <tr>
                    <th id="attribute-label" scope="col"></th>
                    <th id="attribute-value" scope="col"></th>
                </tr>
            </thead>
            <tbody>
                {data && keys.map((key) => {
                    return <ProfileAttributeTableFragmentGenerator
                        fieldType="integer"
                        key={key}
                        name={key}
                        data={data[key]}
                        translationFile="number_of_sites"
                        valueChangeHandler={valueChangeHandler}
                        isRequiredField={false} />
                })}
            </tbody>
        </table>
    )
}

export default NumberOfSitesTab